<template>
  <v-card>
    <v-card-title>
      <v-layout column ma-0>
        <span class="headline">Credit Notes</span>
        <span>{{ invoiceId }}</span>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeModal">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container py-0>
        <v-layout v-if="(creditNotes.length === 0)">This invoice has no credit notes.</v-layout>
        <v-layout v-else v-for="i in creditNotes.length" :key="`${i}`" wrap>
          <v-flex xs12 sm8 my-2>
            <span style="color: rgba(0, 0, 0, 0.54)">ID</span>
            <br />
            <span style="font-size: 16px">{{ creditNotes[i - 1].id }}&nbsp;</span>
          </v-flex>
          <v-flex xs12 sm4 my-2>
            <span style="color: rgba(0, 0, 0, 0.54)">Status</span>
            <br />
            <span style="font-size: 16px">{{ creditNotes[i - 1].status }}&nbsp;</span>
          </v-flex>
          <v-flex xs12 sm5 my-2>
            <span style="color: rgba(0, 0, 0, 0.54)">Reason</span>
            <br />
            <span style="font-size: 16px">{{ creditNotes[i - 1].reason }}&nbsp;</span>
          </v-flex>
          <v-flex xs12 sm3 my-2>
            <span style="color: rgba(0, 0, 0, 0.54)">Amount</span>
            <br />
            <span style="font-size: 16px">{{ creditNotes[i - 1].amount }}&nbsp;</span>
          </v-flex>
          <v-flex xs12 sm4 my-2>
            <span style="color: rgba(0, 0, 0, 0.54)">Creation time</span>
            <br />
            <span style="font-size: 16px">{{ creditNotes[i - 1].created }}&nbsp;</span>
          </v-flex>
          <v-flex xs12 my-2>
            <v-btn @click.stop="creditNotesPdf(creditNotes[i - 1].pdf)">
              PDF&nbsp;
              <v-icon>cloud_download</v-icon>
            </v-btn>
          </v-flex>
          <v-flex v-if="(i !== creditNotes.length)" xs12 my-2>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" outlined @click.prevent="closeModal">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import fb from "@/firebase";
//import { mapState, mapMutations } from "vuex";

export default {
  name: "CreditNotesInfo",
  props: {
    invoiceId: String
  },
  data: () => ({
    creditNotes: []
  }),
  computed: {},
  mounted() {
    fb.db
      .collection("stripe_credit_notes")
      .where("invoice", "==", this.invoiceId)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          this.creditNotes.push(doc.data());
        });
      });
  },
  methods: {
    //...mapMutations(["setAppAlert"]),
    creditNotesPdf(item) {
      window.open(item, "PDFwindow");
    },
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>
